module.exports = __webpack_public_path__ + "static/media/feticcio.c9002cc8.jpg";